import httpClient from "../../api/httpClient";
import justificativaDomain from "../classes/JustificativaDomain";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "JustificativaDomain/All" },
  { method: "GET", rota: "JustificativaDomain/{id}" },
  { method: "POST", rota: "JustificativaDomain/Adicionar" },
  { method: "PUT", rota: "JustificativaDomain/Atualizar" },
  { method: "POST", rota: "JustificativaDomain/Apagar" }
];

const cacheKey: string = "justificativaCache";
const cacheKeySelC: string = "justificativaSelecionado";

const apiServico: String = "PLANEJAMENTO"

class JustificativaDataset extends httpClient {

  constructor() {
    super(String(apiServico));
  }

  async ListarAtivos(): Promise<justificativaDomain[]> {
    return await super.Get(calls[0].rota)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  Adicionar(value: justificativaDomain) {
    let ok: boolean = false;
    let error: any = undefined;
    super.post(calls[2].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  Atualizar(value: justificativaDomain) {
    let ok: boolean = false;
    let error: any = undefined;
    super.put(calls[3].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  Apagar(value: justificativaDomain) {
    let ok: boolean = false;
    let error: any = undefined;
    super.post(calls[4].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  getKeyCach(): string {
    return cacheKey;
  }

  getKeyCachClass(): string {
    return cacheKeySelC;
  }

  ListarFromCache(): justificativaDomain[] {
    let result: justificativaDomain[] = JSON.parse(cacheKey);
    return result;
  }

  AdicionarListaAoCache(value: justificativaDomain[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  AdicionarObjetoAoCache(value: justificativaDomain) {
    localStorage.setItem(cacheKeySelC, JSON.stringify(value));
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }

}
export default JustificativaDataset;

